// Imports
    // React
    import { useState, useEffect } from 'react'
    import { useParams, Link, useNavigate } from 'react-router-dom'
    // Firebase
    import { getCombosById, updateCombo, uploadComboPicture } from '../firebase/FirebaseClient'
    // Icons
    import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
    import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
    import { FiDelete, FiSave } from "react-icons/fi"



// rafce
    const CombosEdit = ( ) => {

        const {id} = useParams()
        const [code, setCode] = useState("")
        const [category, setCategory] = useState("")
        const [name, setName] = useState("")
        const [description, setDescription] = useState("")
        const [picture, setPicture] = useState("")
        const [price, setPrice] = useState("")
        const [stock, setStock] = useState("")

        const navigate = useNavigate()

        // Get combos from Firestore
        useEffect( () => {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
            getCombosById(id).then( data => {
                setCode(data.code)
                setCategory(data.category)
                setName(data.name)
                setDescription(data.description)
                setPicture(data.picture)
                setPrice(data.price)
                setStock(data.stock)
            })
        }, [])

        // Get categories checkboxes
        const previousCheckboxes = () => {
            for(let i=0; i<category.length; i++){
                if(category[i]){
                    const selected = category[i]
                    document.getElementById(selected).setAttribute("checked", "true")
                }
            }
        }

        // Update checkboxes
        const handleCheckboxes = () => {
            const checkboxes = document.querySelectorAll('input[type=checkbox]')
            category.splice(0,category.length)
            for(let i=0; i<checkboxes.length; i++){
                if(checkboxes[i].checked == true){
                    category.push(checkboxes[i].value)
                }
            }
        }

        // Bring picture from form
        const [uploadedPicture, setUploadedPicture] = useState(null)
        
        // Update combo
        const [ loading, setLoading ] = useState(false);
        const update = async(e) => {
            e.preventDefault()
            setLoading(true)
            document.getElementsByClassName("admin-wait")[0].removeAttribute("style")
            document.getElementsByClassName("admin-form-buttons")[0].setAttribute("style", "display: none;")
            handleCheckboxes()
            if(uploadedPicture === null){
                try {
                    updateCombo(id,
                                code,
                                category,
                                name,
                                description,
                                picture,
                                price,
                                stock)
                } catch (error) {
                    alert("El combo no se actualizó correctamente, por favor intente de nuevo")  
                }
            }
            else{
                const pictureUrl = await uploadComboPicture(uploadedPicture)
                try {
                    updateCombo(id,
                                code,
                                category,
                                name,
                                description,
                                pictureUrl,
                                price,
                                stock)
                 } catch (error) {
                     alert("El combo no se actualizó correctamente, por favor intente de nuevo")  
                 }
                 setUploadedPicture(null)
            }
            setLoading(false)
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            navigate(`/admin/combos`)
        }

        // Component
        return (
            <div className='main-admin' onLoad={previousCheckboxes()}>
                <Link to="/admin/combos/"><FontAwesomeIcon icon={ faRightFromBracket } flip="horizontal" size="2x" /></Link>
                <form className='admin-form' onSubmit={update}>
                    <span>Editar Combo</span>
                    <ul className='admin-form-categories'>
                        <li>
                            <input
                                type="checkbox"
                                name="category"
                                value="ofertas"
                                id="ofertas" />
                                <label htmlFor='ofertas'>Ofertas</label>
                        </li>
                        <li>
                            <input
                                type="checkbox"
                                name="category"
                                value="50-personas"
                                id="50-personas" />
                                <label htmlFor='50-personas'>50 Personas</label>
                        </li>
                        <li>
                            <input
                                type="checkbox"
                                name="category"
                                value="75-personas"
                                id="75-personas" />
                                <label htmlFor='75-personas'>75 Personas</label>
                        </li>
                        <li>
                            <input
                                type="checkbox"
                                name="category"
                                value="100-personas"
                                id="100-personas" />
                                <label htmlFor='100-personas'>100 Personas</label>
                        </li>
                        <li>
                            <input
                                type="checkbox"
                                name="category"
                                value="150-personas"
                                id="150-personas" />
                                <label htmlFor='150-personas'>150 Personas</label>
                        </li>
                        <li>
                            <input
                                type="checkbox"
                                name="category"
                                value="destacados"
                                id="destacados" />
                                <label htmlFor='destacados'>Destacados</label>
                        </li>
                    </ul>
                    <input
                        className="admin-form-text-box"
                        name="code"
                        type="text"
                        value={code}
                        maxLength={4}
                        required
                        onChange={ (e) => setCode(e.target.value) } />  
                    <input
                        className="admin-form-text-box"
                        name="name"
                        type="text"
                        value={name}
                        required
                        onChange={ (e) => setName(e.target.value) } />
                    <textarea
                        className="admin-form-text-area"
                        name="description"
                        type="text"
                        value={description}
                        required
                        onChange={ (e) => setDescription(e.target.value) } />
                    <label>
                        IMAGEN
                        <input 
                            className="admin-form-text-box"
                            name="picture"
                            type="file"
                            onChange={ (e) => setUploadedPicture(e.target.files[0]) } />
                        Seleccione sólo si desea modificar la imagen existente. En caso de querer mantener la misma, no seleccione ningún archivo.
                    </label>
                    <input
                        className="admin-form-text-box"
                        name="price"
                        type="number"
                        step="0.01"
                        onWheel={e => e.target.blur()}
                        value={price}
                        required
                        onChange={ (e) => setPrice(e.target.value) } />
                    <input
                        className="admin-form-text-box"
                        name="stock"
                        type="number"
                        onWheel={e => e.target.blur()}
                        value={stock}
                        required
                        onChange={ (e) => setStock(e.target.value) } />
                    <p className='admin-wait' style={{display:"none"}}>Por favor aguarde...</p>
                    <div className='admin-form-buttons'>
                        <button className="admin-item-button" type="submit" disabled={loading}>Guardar<FiSave /></button>
                        <Link className="admin-item-button" to="/admin/combos/">Cancelar<FiDelete /></Link>
                    </div>
                </form>
            </div>
        )
        
    }
    
export default CombosEdit
